import { flairOf, type IceRacer } from '@xox/shared'
import { Avatar } from '../components/Avatar'
import { Standings as RaceStandings, type StandingRow } from '../components/race/Standings'
import { ordinal } from '../lib/format'
import { Skater } from './art/Skater'

/** Finished racers first (by place), then everyone else by points. */
function sortStandings(racers: IceRacer[], scores: Record<string, number>): IceRacer[] {
  return [...racers].sort((a, b) => {
    if (a.place !== null && b.place !== null) return a.place - b.place
    if (a.place !== null) return -1
    if (b.place !== null) return 1
    return (scores[b.profile.id] ?? 0) - (scores[a.profile.id] ?? 0)
  })
}

interface Props {
  racers: IceRacer[]
  scores: Record<string, number>
  hostId: string
  me: string | null
  layout: 'list' | 'strip'
}

export function Standings({ racers, scores, hostId, me, layout }: Props) {
  const byId = new Map(racers.map((r) => [r.profile.id, r]))
  const rows: StandingRow[] = sortStandings(racers, scores).map((r) => ({
    id: r.profile.id,
    nickname: r.profile.nickname,
    isHost: r.profile.id === hostId,
    online: r.online,
    status:
      r.place !== null ? (
        <span className="font-bold text-emerald-600">{ordinal(r.place)}</span>
      ) : r.moves > 0 ? (
        `${r.moves} mv`
      ) : (
        ''
      ),
    score: scores[r.profile.id] ?? 0,
  }))
  return (
    <RaceStandings
      rows={rows}
      me={me}
      layout={layout}
      figure={(row, l) => {
        const r = byId.get(row.id)!
        return l === 'strip' ? (
          <Skater color={flairOf(r.profile).color} className="h-7" />
        ) : (
          <Avatar id={r.profile.id} avatar={r.profile.avatar} color={r.profile.color} size="sm" />
        )
      }}
    />
  )
}
